import { isChainSupported } from '@emberswap/emberswap-sdk2/dist/functions'
import { useDeferredValue, useEffect } from 'react'
import { usePublicClient } from 'wagmi'
import { useNetwork } from 'wagmi'

import { useSessionChainId } from '../../state/application/hooks'
import { useWeb3React } from './useWeb3React'

/**
 * @return {number | undefined} ChainId
 */
function useLocalNetworkChain() {
  const { chain } = useNetwork()
  const [sessionChainId, { updateChainId }] = useSessionChainId()

  useEffect(() => {
    if (chain && isChainSupported(chain.id)) {
      updateChainId(chain.id)
    }
  }, [chain, updateChainId])

  const chainId = +(chain?.id || sessionChainId)
  if (isChainSupported(chainId)) {
    return chainId
  }
  return undefined
}

export const useActiveChainId = () => {
  const localChainId = useLocalNetworkChain()

  const { chain } = useNetwork()
  const chainId = localChainId ?? chain?.id

  const isNotMatched = useDeferredValue(chain && localChainId && chain.id !== localChainId)

  return {
    chainId,
    isWrongNetwork: (chain?.unsupported ?? false) || isNotMatched,
    isNotMatched,
  }
}
/**
 * Provides a web3 publicClient with or without user's signer
 * Recreate web3 instance only if the publicClient change
 * @return {useWeb3React}
 */
const useActiveWeb3React = () => {
  const web3React = useWeb3React()
  const { chainId, isWrongNetwork } = useActiveChainId()
  const publicClient = usePublicClient({ chainId })

  return {
    publicClient,
    ...web3React,
    chainId,
    isWrongNetwork,
  }
}

export default useActiveWeb3React
